<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l47kzh/tc-custom/9781035810178.jpg?1718072563364" alt="This image is the cover for the book Simple Exercises"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Simple Exercises
      </h1>
      <p class="bookDescription body article font2">
        <p>Simple Exercises is a deeply personal collection of poems by Czech-born Australian poet Josef A Tomáš. Spanning over 40 years of the poet’s life, from his early days as a refugee in Australia to his later years, these emotive poems capture singular moments and reflect on universal themes of love, loss, belonging, death, and the divine. <br/>Many of the poems originated on Tomáš’ daily train journeys, observing his fellow passengers and translating the rhythms of travel into poetic meditations. Other poems are grounded in vivid sensory detail: the texture of a cold day, the sound of a soprano filling a concert hall, the sight of autumn leaves falling. Underlying much of the collection is a profound connection to music and an acute sensitivity to fleeting yet powerful epiphanies in everyday life. <br/>Simple Exercises charts the evolution of a poetic voice through quiet transformations, from a young man cut off from his native culture to an elder poet at one with the universe inside him. Tomáš distils wonder, grief, hope and insight into delicate poems that reward quiet contemplation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josef A Tomáš
      </h2>
      
      <p class="authorDescription body article">Josef Tomáš, born in Czechoslovakia in 1933, pursued a mechanical engineering degree at the Czech Technical University in Prague, graduating in 1957. His academic journey continued with a PhD in the Theory of Nonlinear Vibrations from the Czech Academy of Sciences in 1966. Until 1993, he held a professorship, later transitioning to the role of owner and director of Advea, an engineering company in Melbourne, until his retirement in 2010 He wrote his first poems in 1980 in the form of letters to his mother. He underwent an intensive learning period from 1980 to 1986, following the advice of T.S. Eliot: “Who wishes to write poetry must keep in training and must do this by good workmanship for some hours’ work every week of his life.” During this period he wrote over 500 poems, mostly on the train from Glen Waverley to the City and back. He then wrote poetry in English under the guidance of Australian poet Philip Martin from 1986 to 1989. A prolific author, Tomáš has penned ten books of poetry in Czech and, since 2006, has translated the works of many Czech poets, along with two of his own books, into English.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?362ea979